import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

import prepare_headers from "../../../store/prepare_headers";
import {IOfferBoxOffer} from "../mocks/singleOfferMock";
import {
    ICbiInvestmentPropertiesResponse,
    ICbiInvestmentProperty,
    ICbiMapOffer,
    ICbiMapOfferDetail,
    ICbiMapResponse,
    IGetOffersListMapParams
} from "./cbi_map.types";
import {appendOfferTypeParams} from "./map_query_params";
import {mapDetailToOfferBoxOffer} from "./offer_box.mapper";

export type {ICbiInvestmentProperty, ICbiMapOffer} from "./cbi_map.types";

export const mapApi = createApi({
    reducerPath: "mapApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "",
        prepareHeaders: prepare_headers,
        credentials: "include"
    }),
    endpoints: (builder) => ({
        getOffersListMap: builder.query<ICbiMapOffer[], IGetOffersListMapParams>({
            query: ({region_id, offerType, pageSize = 1000}) => {
                const params = new URLSearchParams({
                    page_size: pageSize.toString(),
                    for_sale: "true",
                    region_id: region_id.toString()
                });
                appendOfferTypeParams(params, offerType);
                return {
                    url: `/api/investments/cbi-map/?${params.toString()}`,
                    method: "GET"
                };
            },
            transformResponse: (res: ICbiMapResponse) => res.results
        }),
        getInvestmentDetail: builder.query<IOfferBoxOffer, string>({
            query: (id) => ({
                url: `/api/investments/cbi-map/${id}/`,
                method: "GET"
            }),
            transformResponse: (res: ICbiMapOfferDetail) => mapDetailToOfferBoxOffer(res)
        }),
        getInvestmentProperties: builder.query<ICbiInvestmentProperty[], string>({
            query: (id) => ({
                url: `/api/investments/cbi-map/${id}/properties/`,
                method: "GET"
            }),
            transformResponse: (res: ICbiInvestmentPropertiesResponse | ICbiInvestmentProperty[]) =>
                Array.isArray(res) ? res : (res?.results ?? [])
        })
    })
});

export const {useGetOffersListMapQuery, useGetInvestmentDetailQuery, useGetInvestmentPropertiesQuery} = mapApi;
